module.exports = __webpack_public_path__ + "908e4d2e/img/SOURCERY_poweredby_web.9819842b.png";